import { persistentAtom } from 'src/utils/atoms/persistentAtom';

export const cloneAtom = persistentAtom<{
  cloneId?: string;
  isPushLive?: boolean;
}>('cloningStatus', { cloneId: undefined, isPushLive: undefined }, { isPerUser: true });
